/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Drawer from '../components/Drawer';
import { chatAPI } from '../services/api';

export default function Chat({ artisan, onDevisDetecte }) {
  const [messages, setMessages] = useState([
    { role: 'assistant', content: `Bonjour ${artisan?.nom_entreprise || ''} ! Je suis Compagnon, votre assistant expert BTP.\n\nJe peux répondre à vos questions métier ET générer vos devis/factures. Dites-moi simplement :\n"Fais-moi un devis pour M. Dupont, pose de carrelage 45m² à 35€/m², TVA 10%"\net je m'occupe du reste ! 🏗️` }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [currentConvId, setCurrentConvId] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const bottomRef = useRef(null);
  const recognitionRef = useRef(null);

  useEffect(() => {
    if (artisan?.id) loadConversations();
  }, [artisan]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const loadConversations = async () => {
    try {
      const convs = await chatAPI.getConversations(artisan.id);
      setConversations(convs);
    } catch {}
  };

  const selectConversation = async (conv) => {
    setCurrentConvId(conv.id);
    try {
      const msgs = await chatAPI.getMessages(conv.id);
      setMessages(msgs.map(m => ({ role: m.role, content: m.content })));
    } catch {}
  };

  const newConversation = () => {
    setCurrentConvId(null);
    setMessages([{ role: 'assistant', content: `Bonjour ! Je suis Compagnon, votre assistant expert BTP. Comment puis-je vous aider ?` }]);
  };

  const extraireDevis = (texte) => {
    try {
      const match = texte.match(/```json\n?([\s\S]*?)\n?```/);
      if (match) { const d = JSON.parse(match[1]); if (d.type_document && d.client_nom) return d; }
      const m2 = texte.match(/\{[\s\S]*?"type_document"[\s\S]*?\}/);
      if (m2) { const d = JSON.parse(m2[0]); if (d.type_document && d.client_nom) return d; }
    } catch {}
    return null;
  };

  const send = async () => {
    if (!input.trim() || loading) return;
    const userMsg = { role: 'user', content: input.trim() };
    const allMsgs = [...messages.filter((m, i) => !(m.role === 'assistant' && i === 0)), userMsg];
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setLoading(true);
    try {
      const res = await chatAPI.send(allMsgs, artisan?.id, currentConvId);
      const devisData = extraireDevis(res.response);
      if (devisData) {
        const propre = res.response
          .replace(/```json[\s\S]*?```/g, '')
          .replace(/\{[\s\S]*?"type_document"[\s\S]*?\}/g, '')
          .trim();
        setMessages(prev => [...prev, {
          role: 'assistant',
          content: propre || '✅ Devis prêt ! Vérifiez les informations et générez le PDF.',
          devisData
        }]);
      } else {
        setMessages(prev => [...prev, { role: 'assistant', content: res.response }]);
      }
      if (res.conversation_id && !currentConvId) {
        setCurrentConvId(res.conversation_id);
        loadConversations();
      }
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: '❌ Une erreur est survenue. Vérifiez votre connexion.' }]);
    } finally {
      setLoading(false);
    }
  };

  const formatMessage = (text) =>
    text.split('\n').map((line, i) => (
      <span key={i}>{line}{i < text.split('\n').length - 1 && <br />}</span>
    ));

  const toggleVoice = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { alert('Reconnaissance vocale non supportée. Utilisez Safari ou Chrome.'); return; }
    if (isRecording) { recognitionRef.current?.stop(); setIsRecording(false); return; }
    const r = new SR();
    r.lang = 'fr-FR'; r.continuous = false; r.interimResults = true;
    r.onstart = () => setIsRecording(true);
    r.onresult = (e) => setInput(Array.from(e.results).map(x => x[0].transcript).join(''));
    r.onend = () => setIsRecording(false);
    r.onerror = () => setIsRecording(false);
    recognitionRef.current = r;
    r.start();
  };

  const barBorderColor = isRecording ? '#e05a5a' : isFocused ? '#4a7abf' : '#2a3a5a';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#0a0a0a' }}>
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        conversations={conversations}
        currentId={currentConvId}
        onSelect={selectConversation}
        onNew={newConversation}
      />

      <div style={{ background: '#0d1117', padding: '14px 16px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '0.5px solid #1a2744', flexShrink: 0 }}>
        <div>
          <p style={{ color: '#e8eaf0', fontSize: 15, fontWeight: 600, margin: 0 }}>Compagnon</p>
          <p style={{ color: '#4a7abf', fontSize: 11, margin: 0 }}>Expert BTP · En ligne</p>
        </div>
        <button onClick={() => setDrawerOpen(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6, display: 'flex', flexDirection: 'column', gap: 3.5 }}>
          {[0, 1, 2].map(i => (
            <span key={i} style={{ display: 'block', width: 18, height: 1.5, background: '#FFD700', borderRadius: 2 }} />
          ))}
        </button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '16px 14px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {messages.map((msg, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start' }}>
            {msg.role === 'assistant' && (
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#FFD700', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 8, flexShrink: 0, marginTop: 2 }}>
                <span style={{ fontSize: 13 }}>⚒</span>
              </div>
            )}
            <div style={{ maxWidth: '80%' }}>
              <div style={{
                background: msg.role === 'user' ? '#0e2040' : '#0d1117',
                border: `0.5px solid ${msg.role === 'user' ? '#1e3a6e' : '#1a2744'}`,
                borderRadius: msg.role === 'user' ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
                padding: '10px 14px',
                fontSize: 13,
                color: '#c8d4e8',
                lineHeight: 1.6,
              }}>
                {formatMessage(msg.content)}
              </div>
              {msg.devisData && (
                <button
                  onClick={() => onDevisDetecte && onDevisDetecte(msg.devisData)}
                  style={{
                    marginTop: 8, width: '100%', background: '#FFD700', color: '#0a0a0a',
                    border: 'none', borderRadius: 12, padding: '10px 14px',
                    fontSize: 12, fontWeight: 700, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                  }}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <rect x="1" y="1" width="12" height="12" rx="2" stroke="#0a0a0a" strokeWidth="1.2" />
                    <path d="M4 5h6M4 7h6M4 9h4" stroke="#0a0a0a" strokeWidth="1.2" strokeLinecap="round" />
                  </svg>
                  Voir et générer le {msg.devisData.type_document || 'devis'}
                </button>
              )}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#FFD700', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: 13 }}>⚒</span>
            </div>
            <div style={{ background: '#0d1117', border: '0.5px solid #1a2744', borderRadius: '14px 14px 14px 4px', padding: '10px 16px' }}>
              <span style={{ color: '#4a7abf', fontSize: 18, letterSpacing: 3 }}>···</span>
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      <div style={{ background: '#0d1117', borderTop: '0.5px solid #1a2744', padding: '10px 12px', flexShrink: 0 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 4,
          background: '#1a1a1a', border: `0.5px solid ${barBorderColor}`,
          borderRadius: 24, padding: '4px 6px 4px 14px', transition: 'border-color 0.2s',
        }}>
          <textarea
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder={isRecording ? 'Écoute en cours…' : 'Question BTP ou demande de devis…'}
            rows={1}
            style={{
              flex: 1, background: 'none', border: 'none', outline: 'none',
              fontSize: 13, color: isRecording ? '#e05a5a' : '#c8d4e8',
              fontFamily: 'inherit', lineHeight: 1.5, resize: 'none', padding: '5px 0',
            }}
          />
          <button
            onClick={toggleVoice}
            style={{
              width: 30, height: 30, borderRadius: '50%', border: 'none',
              background: isRecording ? '#e05a5a' : 'transparent',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', flexShrink: 0, padding: 0,
              animation: isRecording ? 'micPulse 1s infinite' : 'none',
            }}>
            <svg width="12" height="14" viewBox="0 0 12 14" fill="none">
              <rect x="3.5" y="0.5" width="5" height="8" rx="2.5" fill={isRecording ? '#fff' : '#4a7abf'} />
              <path d="M1 7c0 2.76 2.24 5 5 5s5-2.24 5-5" stroke={isRecording ? '#fff' : '#4a7abf'} strokeWidth="1.2" strokeLinecap="round" />
              <line x1="6" y1="12" x2="6" y2="13.5" stroke={isRecording ? '#fff' : '#4a7abf'} strokeWidth="1.2" strokeLinecap="round" />
              <line x1="4" y1="13.5" x2="8" y2="13.5" stroke={isRecording ? '#fff' : '#4a7abf'} strokeWidth="1.2" strokeLinecap="round" />
            </svg>
          </button>
          <button
            onClick={send}
            disabled={loading || !input.trim()}
            style={{
              width: 30, height: 30, borderRadius: '50%', border: 'none',
              background: input.trim() && !loading ? '#FFD700' : '#2a3a5a',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: input.trim() && !loading ? 'pointer' : 'default',
              flexShrink: 0, padding: 0, transition: 'background 0.2s',
            }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M1 6L11 1L7.5 6L11 11L1 6Z" fill={input.trim() && !loading ? '#0a0a0a' : '#4a7abf'} />
              <line x1="7.5" y1="6" x2="1" y2="6" stroke={input.trim() && !loading ? '#0a0a0a' : '#4a7abf'} strokeWidth="1" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        {isRecording && (
          <p style={{ textAlign: 'center', fontSize: 10, color: '#e05a5a', margin: '5px 0 0' }}>
            Parlez maintenant — appuyez à nouveau pour arrêter
          </p>
        )}
      </div>
      <style>{`@keyframes micPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.12)}}`}</style>
    </div>
  );
}
